import { render } from "./OurManagement.vue?vue&type=template&id=370ea9a3&scoped=true"
import script from "./OurManagement.vue?vue&type=script&lang=js"
export * from "./OurManagement.vue?vue&type=script&lang=js"

import "./OurManagement.vue?vue&type=style&index=0&id=370ea9a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370ea9a3"]])

export default __exports__